<template>
  <div class="overflow-hidden">
    <div class="z-[9999] fixed w-full top-0 left-0 bg-black">
      <Container>
        <div class="navbar py-5">
          <div class="navbar-start">
            <NuxtLink to="/" no-prefetch>
              <NuxtImg
                class="h-7 md:h-10 object-contain"
                src="/surya-bintang-logo-dark.png"
                alt="logo"
                format="webp"
                fetchPriority="high"
              />
            </NuxtLink>
          </div>

          <div class="navbar-end">
            <div class="hidden lg:block">
              <div class="flex justify-center space-x-6">
                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.home') }}
                </NuxtLink>
                
                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/about"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.about') }}
                </NuxtLink>
       
                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/our-history"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.our_history') }}
                </NuxtLink>

                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/activities"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.activities') }}
                </NuxtLink>
                
                <NuxtLink
                  class="relative btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/kayaking"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.kayaking') }}
                  <span class="pointer-events-none absolute -top-1 -right-3 px-1.5 py-0.5 rounded-full text-[9px] font-medium leading-none bg-red-500/90 text-white whitespace-nowrap">
                    Favorite
                  </span>
                </NuxtLink>

                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/e-bikes"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.e-bikes') }}
                </NuxtLink>

                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/restaurant"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.restaurant') }}
                </NuxtLink>

                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/blog"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.blog') }}
                </NuxtLink>

                <NuxtLink
                  class="btn btn-ghost transition-all duration-300 normal-case rounded-none btn-sm text-sm font-normal h-[38px] text-white hover:text-black hover:bg-white hover:rounded-lg"
                  to="/contact-us"
                  active-class="!font-semibold"
                  no-prefetch
                >
                  {{ $t('nav.contact') }}
                </NuxtLink>

                <NuxtLink
                  v-if="$isLogin"
                  class="btn btn-sm text-base font-normal h-[38px] rounded-none normal-case bg-black text-white px-5 transition-all duration-300 outline-none border-none hover:bg-white hover:rounded-lg hover:text-black"
                  :to="dashboardLink"
                  no-prefetch
                >
                  Dashboard
                </NuxtLink>
              </div>
            </div>
            <div class="block lg:hidden">
              <div class="flex items-center space-x-2">
                <div>
                </div>
                <button
                  @click="toggleMobileMenu"
                  class="btn-sm text-base font-normal normal-case text-white"
                  type="button"
                  aria-label="Menu"
                >
                  <Icon name="i-heroicons-bars-3" class="h-7 w-7" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>

    <!-- Mobile Menu Overlay -->
    <div 
      v-if="isMobileMenuOpen" 
      @click="closeMobileMenu"
      class="fixed inset-0 bg-black bg-opacity-50 z-[9998] lg:hidden"
    ></div>

    <!-- Mobile Menu Sidebar -->
    <div 
      :class="[
        'fixed top-0 left-0 h-full w-80 bg-black z-[9999] transform transition-transform duration-300 ease-in-out lg:hidden',
        isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
      ]"
    >
      <div class="flex flex-col h-full">
        <!-- Header with close button -->
        <div class="flex items-center justify-between p-6">
          <NuxtImg
            class="h-8"
            src="/surya-bintang-logo-dark.png"
            alt="logo"
            format="webp"
            height="32"
            width="70"
          />
          <div class="flex items-center space-x-3">
            <button
              @click="closeMobileMenu"
              class="btn-square text-white transition-all duration-300"
              aria-label="Close menu"
            >
              <Icon name="i-heroicons-x-mark" class="h-5 w-5" />
            </button>
          </div>
        </div>

        <!-- Navigation Links -->
        <nav class="flex-1 p-6">
          <ul class="space-y-4">
            <li>
              <NuxtLink 
                to="/" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/' }"
                no-prefetch
              >
                {{ $t('nav.home') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/about" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/about' }"
                no-prefetch
              >
                {{ $t('nav.about') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/our-history" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/our-history' }"
                no-prefetch
              >
                {{ $t('nav.our_history') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/activities" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/activities' }"
                no-prefetch
              >
                {{ $t('nav.activities') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/kayaking" 
                @click="closeMobileMenu"
                class="relative block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/kayaking' }"
                no-prefetch
              >
                {{ $t('nav.kayaking') }}
                <span class="pointer-events-none absolute top-2 left-[60px] px-1.5 py-0.5 rounded-full text-[9px] font-medium leading-none bg-red-500/90 text-white whitespace-nowrap">
                  Favorite
                </span>
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/e-bikes" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/e-bikes' }"
                no-prefetch
              >
                {{ $t('nav.e-bikes') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/restaurant" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/restaurant' }"
                no-prefetch
              >
                {{ $t('nav.restaurant') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/blog" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/blog' }"
                no-prefetch
              >
                {{ $t('nav.blog') }}
              </NuxtLink>
            </li>
            <li>
              <NuxtLink 
                to="/contact-us" 
                @click="closeMobileMenu"
                class="block w-full text-left px-4 py-5 text-white hover:bg-white hover:text-black transition-all duration-300 rounded-lg"
                :class="{ 'bg-white !text-black': $route.path === '/contact-us' }"
                no-prefetch
              >
                {{ $t('nav.contact') }}
              </NuxtLink>
            </li>
          </ul>
        </nav>

        <!-- Footer with Dashboard button -->
        <div class="p-6 border-t border-gray-700">
          <div v-if="$isLogin" class="mb-4">
            <NuxtLink
              :to="dashboardLink"
              @click="closeMobileMenu"
              class="btn btn-neutral rounded-full normal-case btn-sm text-base font-normal h-10 btn-block"
              aria-label="Dashboard"
            >
              Dashboard
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <main class="min-h-screen">
      <slot />
    </main>
    <FloatingButton />
    <StevaniFooter />
    <NuxtSnackbar />
  </div>
</template>

<script setup lang="ts">
const { $isLogin, $isAgen, $isAdmin, $isUser } = useAuth()
const store = useProductStore()

// Mobile menu state
const isMobileMenuOpen = ref(false)

const dashboardLink = computed(() => {
  if ($isAdmin.value) {
    return '/admin'
  }
  if ($isAgen.value) {
    return '/agent'
  }
  return '/user'
})

const availableCart = computed(() => {
  return store.availableCart
})

const isAgentOrUser = computed(() => {
  return $isUser.value || $isAgen.value
})

// Mobile menu functions
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
}

// Close menu when route changes
watch(() => useRoute().path, () => {
  closeMobileMenu()
})

// Close menu on escape key
onMounted(() => {
  const handleEscape = (e: KeyboardEvent) => {
    if (e.key === 'Escape' && isMobileMenuOpen.value) {
      closeMobileMenu()
    }
  }
  
  document.addEventListener('keydown', handleEscape)
  
  onUnmounted(() => {
    document.removeEventListener('keydown', handleEscape)
  })
})

const { href } = useCanonical()
const { t: $t } = useI18n()

const structuredData = ref({
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: 'Surya Bintang Adventures',
  description: $t('meta.home.description'),
  image: 'https://suryabintangadventures.com/_ipx/f_webp&s_176x80/surya-bintang-logo-dark.png',
  url: href,
  telephone: '+62818881388',
  priceRange: '$$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Jl. Raya Payangan, Melinggih Kelod, Kec. Payangan, Kabupaten Gianyar, Bali 80572',
    addressLocality: 'Gianyar',
    postalCode: '80572',
    addressCountry: 'ID'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -8.45048431470221,
    longitude: 115.24289531349369
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '08:00',
      closes: '17:00'
    }
  ],
  sameAs: [
    'https://www.instagram.com/suryabintang_adventures/',
    'https://www.youtube.com/@suryabintangadventures',
    'https://www.facebook.com/suryabintangadventurebali'
  ]
})

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify(structuredData.value)
    }
  ]
})
</script>

<style scoped></style>
